import { emptySplitApi } from './index'

const loginApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    login: builder.mutation({
      query: (model) => ({
        url: `api/v1/auth-service/login`,
        method: "POST",
        body: model,
      }),
      
    }),
    logout: builder.mutation({
      query: () => ({
        url: `api/v1/auth-service/login`,
        method: "DELETE",
      }),
    }),
    verifyTwoFactor: builder.mutation({
      query: (model) => ({
        url: `api/v1/auth-service/login/verify-2fa`,
        method: "POST",
        body: model,
      }),
    }),
    resendTwoFactor: builder.mutation({
      query: (model) => ({
        url: `api/v1/auth-service/login/resend-2fa`,
        method: "POST",
        body: model,
      }),
    }),
    refreshToken: builder.mutation({
      query: (model) => ({
        url: `api/v1/auth-service/token/refresh`,
        method: "POST",
        body: model,
      }),
    }),
  }),
  overrideExisting: false,
});

export const { useLoginMutation, useLogoutMutation, useRefreshTokenMutation, useVerifyTwoFactorMutation, useResendTwoFactorMutation } = loginApi;
